this.trap_focus = function ($container, event_namespace) {
	var event_name = event_namespace ? 'focusin.' + event_namespace : 'focusin';
	var event_name_keyup = event_namespace ? 'keyup.' + event_namespace : 'keyup';
	var clickables = $container.find('button:visible, a:visible, input:visible, select:visible, textarea:visible, [tabindex]:not([tabindex="-1"]:visible)');
	var first = clickables.first();
	var last = clickables.last();

	$container.attr('tabindex', '-1');
	first.focus();

	$(document).on(event_name_keyup, function (event) {
		if (event.shiftKey) {
			//set shiftKey on container to detect when the user is going backwards
			$container.shiftKey = true;
		} else {
			// otherwise set to false this is to reset it if the user changes direction
			$container.shiftKey = false;
		}
	}).on(event_name, function (event) {
		// re-select the target clickable items (in case any item was hidden initially)
		var clickablesNew = $container.find('button:visible, a:visible, input:visible, select:visible, textarea:visible, [tabindex]:not([tabindex="-1"]:visible)');

		// compare if the first item changed. If so, use the new first item instead
		if (clickablesNew[0] !== clickables[0]) {
			first = clickablesNew.first();
		}

		// compare if the last item changed. If so, use the new last item instead
		if (clickablesNew[clickablesNew.length - 1] !== clickables[clickables.length - 1]) {
			last = clickablesNew.last();
		}
		// get the current focusin element index value of the clickable elements set
		var currentIndex = clickables.toArray().indexOf(event.target);
		switch (true) {
			case currentIndex === clickables.length - 1:
				// when the last clickable element receives only a tab key press (no shift key press), focus the first clickable element of the set 
				last.off('keydown').on('keydown', function (event) {
					if (event.key === 'Tab' && !event.shiftKey) {
						event.preventDefault();
						first.focus();
					}
				});
				break;
			case currentIndex === 0:
				// when the first clickable element receives a tab key and shift key press, focus the last clickable element of the set 
				first.off('keydown').on('keydown', function (event) {
					if (event.key === 'Tab' && event.shiftKey && $container.attr('tabindex') === '-1') {
						event.preventDefault();
						last.focus();
					}
				});
				break;
		}
	});
};

this.remove_trap_focus = function ($container, event_namespace) {
	var event_name = event_namespace ? 'focusin.' + event_namespace : 'focusin';
	var event_name_keyup = event_namespace ? 'keyup.' + event_namespace : 'keyup';

	$container.removeAttr('tabindex');
	$(document).off(event_name).off(event_name_keyup);
};